<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.375" y="1.61499" width="17.25" height="11.25" rx="5.625" stroke="currentColor" stroke-width="1.75"/>
</svg>
